<div style="display:flex;justify-content:space-between;margin-bottom:0.5rem;margin-top:0.5rem;">
    <span style="font-weight:bold">{{ 'Selected bots' | translate }}</span>
</div>
<div id="group-mandatory" class="form-group table table-hover list-table determinants-table">
    <div class="list-table determinants-table">
        <div class="d-flex">
            <div id="item-mandatory" class="item-mandatory d-flex flex-grow-1 flex-column" 
                 cdkDropList 
                [cdkDropListData]="botSelection" 
                (cdkDropListDropped)="dropped($event)">
                <div cdkDrag class="d-flex align-items-baseline item-mandatory-item p-2"
                    *ngFor="let item of botSelection; let i=index;">
                    <div class="determinant-element-row d-flex flex-grow-1 pl-2 pr-0 py-2 justify-content-between">
                        <span>{{item.name}}</span>
                        <i *ngIf="!readOnly" class="btn-xs btn-bordered btn-danger btn-icon fas fa-times"
                            (click)="removeBot(i)"></i>
                    </div>
                </div>
                <div class="d-flex align-items-baseline my-auto" *ngIf="!botSelection || (botSelection && botSelection.length === 0)">
                    <div class="determinant-element-row d-flex flex-grow-1 p-2 justify-content-center">
                        <span>{{noneSelectedText | translate}}</span>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
